import { Injectable } from '@angular/core';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class WebPageService {
    constructor(private datatask: DataTaskService) {}

    /**
     * @datatask 1244
     * @datataskName sp_ws_p2_w_webpagelink_settings
     * @param params the keyno of the webpage.
     * @returns promise containing the page get for webpage link.
     */
    public async getWebPageLink(params: GetWebPageLinkParams): Promise<WebPageLinkGet> {
        return (await this.datatask.Post(1244, params))[0];
    }

    /**
     * @datatask 3489
     * @datataskName sp_ws_p2_w_webpagelink_set_menugrp_keyno
     * @param params the keyno of the webpage link and the menu group.
     * @returns promise containing validation for the save.
     */
    public async setWebPageLinkToMenuGroup(params: SetWebPageLinkToMenuGroupParams): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(3489, params))[0];
    }

    /**
     * @datatask 1183
     * @datataskName sp_ws_p2_w_webpagesubscription_get
     * @param params the argtype and argvalue.
     * @returns promise containing the page get for webpage subscription.
     */
    public async getWebPageSubscription(params: GetWebPageSubscriptionParams): Promise<WebPageSubscriptionGet> {
        return (await this.datatask.Post(1183, params))[0];
    }

    /**
     * @datatask 22
     * @datataskName sp_ws_p2_p2webpagetable_get
     * @param params the keyno of the webpage table.
     * @returns promise containing the webpage edit.
     */
    public async getWebPageTableEdit(params: GetWebPageTableEditParams): Promise<WebPageTableEditGet> {
        return (await this.datatask.Post(22, params))[0];
    }

    /**
     * @datatask 23
     * @datataskName sp_ws_p2_p2webpagetable_save
     * @param params the webpage to save
     * @returns promise containing validation
     */
    public async saveWebPageTableEdit(params: WebPageTableEditGet): Promise<{ iserror: '1' | '0'; message: string }> {
        return (await this.datatask.Post(23, params))[0];
    }
}

export interface SetWebPageLinkToMenuGroupParams {
    menugrp_keyno: string | number;
    p2_webpagelink_keyno: string | number;
}

export interface GetWebPageLinkParams {
    p2_webpage_keyno: string | number;
}

export interface WebPageLinkGet {
    searchtext: string;
    p2_webpage_keyno: string;
    menugrp_keyno: string;
    webpage_heading: string;
}

export interface GetWebPageSubscriptionParams {
    argtype: 'webpage_name' | 'p2_subscription_keyno' | 'p2_webpage_keyno';
    argvalue: string;
}

export interface WebPageSubscriptionGet {
    webpage_heading: string;
    searchtext: string;
}

export interface GetWebPageTableEditParams {
    p2_webpage_table_keyno: string | number;
}

export interface WebPageTableEditGet {
    p2_webpage_table_keyno: string;
    webpage_name: string;
    table_name: string;
    include: '1' | '0';
}
